export const CARD_WEIGHTS = {
  A: 40,
  K: 30,
  Q: 25,
  J: 15,
  T: 17,
  9: 12,
  8: 10,
  7: 8,
  6: 6,
  5: 5,
  4: 4,
  3: 3,
  2: 2,
};
